import React from 'react';
import NodeDataTable from '../components/NodeDataTable';

function Nodes() {
  return (
    <div>
      <h1> </h1>
      <NodeDataTable/>
    </div>
  );
}

export default Nodes;
